<template>
  <div>
    <jd-table
      :tableData="newPrizeList"
      :tableInfo="newTableInfo"
      :isIndex="isIndex"
      :indexLabel="indexLabel"
      :indexWidth="70"
    >
      <!-- 预留额外插槽提供额外字段传入 -->
      <template #[item.slot]="{ row, rowIndex }" v-for="item in slotList">
        <slot
          :name="item.slotName"
          :scopeRow="row"
          :scopeIndex="rowIndex"
        ></slot>
      </template>
      <template #rankHeader>
        <slot name="rankHeader"></slot>
      </template>
      <template #prizeTypeSlot="{ row }">
        {{ getPrizeTypeName(row.prizeType) }}
      </template>
      <template #logoSlot="{ row }">
        <div class="logo-style">
          <img v-if="row.logo" :src="row.logo" />
        </div>
      </template>
      <template #titleHeader>
        <span style="color: red">*</span>奖品名称（12字内）
      </template>
      <!--   class="title-input" -->
      <!--   :disabled="row.prizeType != 3 || row.isGoodManage" -->
      <template #titleSlot="{ row }">
        <el-input
          v-model="row.title"
          maxlength="12"
          show-word-limit
          placeholder="请输入"
        ></el-input>
      </template>
      <template #totalAmountHeader>
        <span style="color: red">*</span>奖品数量
      </template>
      <template #totalAmountSlot="{ row }">
        <el-input
          v-model="row.totalAmount"
          @input.native="(e) => (row.totalAmount = checkputn(e, row))"
          placeholder="请输入"
          @input="
            row.totalAmount = getNumberData(1, $event, 0, 1, 999999);
            prizeNum(row);
          "
          @blur="beAdd(row)"
          :disabled="(isDisabled && !row.minNum) || isDisabled||isDisabledTotal"
        ></el-input>
      </template>
      <template #remanentAmount="{ row }">
        <el-input
          v-model.number="row.remanentAmount"
          style="width: 90px"
          disabled
        ></el-input>
        份
      </template>
      <template #operationSlot="{ row, rowIndex }">
        <div class="flexc-cen-x">
          <jd-button
            type="blueText"
            @click="selectGoodFn(row, rowIndex)"
            :disabled="isDisabled&&!row.isAdd"
            >选择奖品</jd-button
          >
          <el-upload
            action="/jd-hd-web/image/upload"
            :show-file-list="false"
            :on-success="(res) => uploadLogo(res, row)"
            :before-upload="(file) => beforeUploadPrize(file)"
            list-type="picture"
            ref="uploadRef"
            :disabled="isDisabled || !row.logo"
            class="ml12 mr12"
            v-if="isShowUpLoadBtn && !isDisabled"
          >
            <jd-button :disabled="isDisabled || !row.logo" type="blueText">
              上传奖品图
            </jd-button>
          </el-upload>
          <jd-button
            type="blueText"
            label="删除"
            v-if="newPrizeList.length > 1"
            :disabled="isDisabled&&!row.isAdd"
            @click="deletePrize(rowIndex)"
          ></jd-button>
          <jd-button
            type="blueText"
            v-if="isShowReset && !isDisabled"
            @click="removePrize(row)"
            >重置</jd-button
          >
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!row.isAdd"
            @click="upPrizeSetting(rowIndex)"
            v-if="isShowMoveBtn && rowIndex != 0"
            >上移</jd-button
          >
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!row.isAdd"
            @click="downPrizeSetting(rowIndex)"
            v-if="isShowMoveBtn && rowIndex != newPrizeList.length - 1"
            >下移</jd-button
          >
          <jd-button
            type="blueText"
            v-if="isDisabled && isShowStock"
            @click="addStock(row, rowIndex)"
            >增加库存</jd-button
          >
        </div>
      </template>
    </jd-table>
    <jd-button
      v-if="isShowAdd"
      @click="addPrize"
      :disabled="isDisabled"
      type="blue"
      class="mt12"
    >
      {{addText}}（{{ newPrizeList.length }}/{{ maxPrizeCount }}）
    </jd-button>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProductRef"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :actType="actType"
      :actEndTime="actEndTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>
<script>
import selectProduct from "../../select_product_componentization.vue";
import addPrizeNum from "../add-prize-num.vue";
export default {
  name: "",
  components: {
    selectProduct,
    addPrizeNum,
  },
  props: {
    // 是否显示添加按钮
    isShowAdd: {
      type: Boolean,
      default: false,
    },
    // 奖品列表
    prizeList: {
      type: Array,
      default: () => [],
    },
    minWidth: {
      type: String,
      default: "90px",
    },
    // 进行中状态
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示索引列
    isHasIndex: {
      type: Boolean,
      default: false,
    },
    valueRow: {
      type: Object,
      default: () => ({}),
    },
    // 表格列配置
    tableInfo: {
      type: Array,
      default: () => [],
    },
    // 最大奖品数量
    maxPrizeCount: {
      type: Number,
      default: 4,
    },
    // 是否显示库存按钮
    isShowStock: {
      type: Boolean,
      default: true,
    },
    // 是否显示上传按钮
    isShowUpLoadBtn: {
      type: Boolean,
      default: false,
    },
    // 是否显示重置按钮
    isShowReset: {
      type: Boolean,
      default: false,
    },
    // 显示序号
    isIndex: {
      type: Boolean,
      default: true,
    },
    actType: {
      type: Number,
      default: 20,
    },
    actEndTime: {
      type: String,
      default: "",
    },
    isShowMoveBtn: {
      type: Boolean,
      default: false,
    },
    addText: {
      type: String,
      default: "添加奖项",
    },
    // 是否禁用奖品数量
    isDisabledTotal: {
      type: Boolean,
      default: false,
    },
    indexLabel: {
      type: String,
      default: "序号",
    },
    otherKey: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      showSelectProduct: false,
      itemArr: [],
      echoDate: {},
      toAddItem: {},
      isShowAddNum: false,
      prizeIndex: -1,
      JingdouCount: {
        prizeCount: 0,
      },
      newTableInfo: JSON.parse(JSON.stringify(this.tableInfo)),
      whitelist: [
        "prizeType",
        "price",
        "title",
        "totalAmount",
        "logo",
        "operation",
        "remanentAmount",
      ], //白名单固定字段：奖品类型，值，奖品名称，奖品数量，图片，操作
    };
  },
  computed: {
    newPrizeList: {
      get() {
        return this.prizeList;
      },
      set(val) {
        this.$emit("update:prizeList", val);
      },
    },
    slotList() {
      // 过滤出不在whitelist中的数据为插槽数据，排除已有静态slot的内置列（如剩余库存）
      return this.newTableInfo.filter(
        (item) => !this.whitelist.includes(item.prop)
      );
    },
  },
  mounted() {
    this.getRemanentInfo();
  },
  methods: {
    upPrizeSetting(index) {
      this.newPrizeList[index] = this.newPrizeList.splice(
        index - 1,
        1,
        this.newPrizeList[index]
      )[0];
    },
    downPrizeSetting(index) {
      this.newPrizeList[index] = this.newPrizeList.splice(
        index + 1,
        1,
        this.newPrizeList[index]
      )[0];
    },
    removePrize(row) {
      row.prizeType = null;
      row.price = null;
      row.title = "";
      row.totalAmount = null;
      row.logo = null;
      row.assetsId = null;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val, row) {
      row.logo = val.data;
    },
    getRemanentInfo() {
      if (this.isDisabled) {
        const hasRemanentCol = this.newTableInfo.some(col => col.slot === "remanentAmount");
        if (hasRemanentCol) return;
        
        // 找到操作列的位置，在操作列前面插入（更可靠）
        const operationIndex = this.newTableInfo.findIndex(col => col.prop === "operation" || col.slot === "operationSlot");
        const insertIndex = operationIndex > -1 ? operationIndex : this.newTableInfo.length - 1;
        
        this.newTableInfo.splice(insertIndex, 0, {
          label: "剩余库存",
          prop: "remanentAmount",
          minWidth: "130",
          slot: "remanentAmount",
        });
      }
    },
    // 删除奖品
    deletePrize(rowIndex) {
      this.newPrizeList.splice(rowIndex, 1);
    },
    // 添加奖品
    addPrize() {
      this.$emit("addPrize");
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.isDisabled) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getPrizeCommon(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
        totalAmount: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime
          ? data.isFollowActivityEndTime
          : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj, prizeType, data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      return prizeObj;
    },
    // 选择奖品弹窗回调
    getTheData(data, prizeType) {
      let prizeObj = this.getPrizeCommon(data, prizeType);
      if(this.newPrizeList[this.prizeIndex].totalAmount) {
        prizeObj.totalAmount = this.newPrizeList[this.prizeIndex].totalAmount;
      }
      if(this.newPrizeList[this.prizeIndex][this.otherKey]!=null||this.newPrizeList[this.prizeIndex][this.otherKey]!=""||this.newPrizeList[this.prizeIndex][this.otherKey]!=undefined) {
        prizeObj[this.otherKey] = this.newPrizeList[this.prizeIndex][this.otherKey];
      }
      if (this.slotList.length) {
        this.slotList.forEach((item) => {
          prizeObj[item.prop] = this.newPrizeList[this.prizeIndex][item.prop];
        });
      }
      this.$set(this.newPrizeList, this.prizeIndex, prizeObj);
      this.showSelectProduct = false;
    },
    //选择奖品弹窗
    selectGoodFn(row, rowIndex) {
      this.JingdouCount.prizeCount = row.totalAmount;
      this.prizeIndex = rowIndex;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.itemArr = this.newPrizeList;
      this.$nextTick(() => {
        this.$refs.selectProductRef.openDialog();
      });
    },
    // 库存更新回调
    confirmAdd(num) {
      this.$set(this.newPrizeList[this.prizeIndex], "totalAmount", Number(num));
      this.isShowAddNum = false;
    },
    // 新增库存
    addStock(row, rowIndex) {
      this.toAddItem = {
        ...row,
        num: row.totalAmount,
      };
      // 选中的奖品下标
      this.prizeIndex = rowIndex;
      this.isShowAddNum = true;
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-style {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  img {
    width: 80px;
    height: 80px;
  }
}

.title-input {
  width: 240px;
}
</style>
